import styled from "styled-components";

export const ContentPrinc = styled.div`  
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  background-color:transparent;
`;
